import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('he'); // Default to Hebrew

    // Load language preference from localStorage on mount
    useEffect(() => {
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage && (savedLanguage === 'he' || savedLanguage === 'en')) {
            setLanguage(savedLanguage);
        }
    }, []);

    // Apply language direction to document
    useEffect(() => {
        const isRTL = language === 'he';
        document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
        document.documentElement.lang = language === 'he' ? 'he' : 'en';
        
        // Add/remove RTL class to body for easier CSS targeting
        if (isRTL) {
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr');
        } else {
            document.body.classList.add('ltr');
            document.body.classList.remove('rtl');
        }
    }, [language]);

    const changeLanguage = (newLanguage) => {
        if (newLanguage === 'he' || newLanguage === 'en') {
            setLanguage(newLanguage);
            localStorage.setItem('language', newLanguage);
        }
    };

    const value = {
        language,
        changeLanguage,
        isHebrew: language === 'he',
        isEnglish: language === 'en'
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};